import { RootState } from 'editor/src/store/index';

import getSelectedMediaElementsObjects from './getSelectedMediaElementsObjects';

const getSelectedImageUuid = (state: RootState) =>
  getSelectedMediaElementsObjects(state).find((element) => element?.type === 'image')?.uuid;

export default getSelectedImageUuid;
